import { getAccountEmail } from '@mc/user-info'

const getEmailDialogUrl = (
  subject = '',
  body = subject,
  emails: string[] = [],
) => {
  const encodedSubject = encodeURIComponent(subject)
  const encodedBody = encodeURIComponent(body)

  const encodedEmails = emails.map((email) => encodeURIComponent(email))
  const emailsToString = encodedEmails.join(',')

  const email = getAccountEmail()
  const domain = email?.substring(email.lastIndexOf('@') + 1) || ''

  let url = `mailto:${emails}?subject=${encodedSubject}&body=${encodedBody}`

  if (domain.includes('gmail')) {
    url = `https://mail.google.com/mail/?view=cm&to=${emailsToString}&su=${encodedSubject}&body=${encodedBody}`
  } else if (domain.includes('hotmail')) {
    url = `https://outlook.live.com/owa/?path=/mail/action/compose&to=${emailsToString}&subject=${encodedSubject}&body=${encodedBody}`
  } else if (domain.includes('yahoo')) {
    url = `https://compose.mail.yahoo.com/?to=${emailsToString}&subject=${encodedSubject}&body=${encodedBody}`
  }

  return url
}

export default getEmailDialogUrl
